/* Impression SCDM - le fil des etapes suit ce que le client a vraiment fait.

   POURQUOI CE FICHIER EXISTE
   --------------------------
   Le fil affichait sept pastilles decoratives : la premiere etait allumee et
   les autres ne bougeaient jamais. Le client ne savait donc pas ou il en etait
   ni combien il restait a faire.

   LA REGLE : une etape ne s allume que si le client Y A TOUCHE.
   Le configurateur part avec des valeurs par defaut (3 po, blanc mat, sans
   vernis, 100). On aurait donc pu declarer toutes les etapes "faites" des le
   chargement - ce qui aurait ete faux et inutile. Une etape passe au vert
   seulement apres une vraie action : un fichier depose, un format choisi, une
   matiere cliquee. L etape active est la premiere qui reste a faire.

   Les deux dernieres, APPROBATION et PRODUCTION, ne sont pas des champs a
   remplir : ce sont les etapes qui viennent APRES la commande. Elles restent
   dans le fil parce que le client doit voir qu il y a une epreuve a approuver
   avant que quoi que ce soit ne s imprime. Production ne se coche jamais sur
   le site : elle se passe a l atelier. */

(function () {
  function quandPret(cb, n) {
    if (window.SCDM && window.SCDM.etat) return cb();
    if ((n || 0) > 100) return;
    setTimeout(function () { quandPret(cb, (n || 0) + 1); }, 50);
  }

  quandPret(function () {
    var fil = document.getElementById('scdmFil');
    if (!fil) return;

    var pas = Array.prototype.slice.call(fil.querySelectorAll('li'));
    if (!pas.length) return;

    var faits = {};

    function peindre() {
      var actif = -1;
      pas.forEach(function (li, i) {
        var cle = li.getAttribute('data-etape') || '';
        var f = !!faits[cle];
        li.classList.toggle('fait', f);
        if (!f && actif < 0) actif = i;
      });
      /* Tout est fait : c est la derniere qui reste en avant. */
      if (actif < 0) actif = pas.length - 1;
      pas.forEach(function (li, i) { li.classList.toggle('actif', i === actif); });
    }

    function fait(cle) {
      if (faits[cle]) return;
      faits[cle] = true;
      peindre();
    }

    function sur(selecteur, evenement, cle, filtre) {
      var e = document.querySelector(selecteur);
      if (!e) return;
      e.addEventListener(evenement, function (ev) {
        if (filtre && (!ev.target.closest || !ev.target.closest(filtre))) return;
        fait(cle);
      });
    }

    /* 1. Fichier - un visuel est charge, televerse ou pris dans la galerie.
       On surveille la barre d outils de l apercu : scdm.js l affiche des qu un
       fichier est accepte, y compris pour un PDF sans apercu. */
    var outils = document.getElementById('scdmOutils');
    var carte = document.getElementById('scdmCarte');
    function verifierFichier() {
      var a = (outils && outils.style.display !== 'none') ||
              (carte && !carte.hidden) ||
              !!(window.SCDM.etat.fichier || window.SCDM.etat.img);
      if (a) fait('fichier');
    }
    if (window.MutationObserver) {
      if (outils) new MutationObserver(verifierFichier).observe(outils, { attributes: true, attributeFilter: ['style'] });
      if (carte) new MutationObserver(verifierFichier).observe(carte, { attributes: true, attributeFilter: ['hidden'] });
    }
    verifierFichier();

    /* 2. Dimensions */
    sur('#scdmTaille', 'change', 'dimensions');
    sur('#scdmLargeur', 'input', 'dimensions');
    sur('#scdmHauteur', 'input', 'dimensions');
    sur('#scdmFormes', 'click', 'dimensions', '[data-champ="forme"]');

    /* 3, 4, 5. Matiere, vernis, quantite - au clic, pas au chargement. */
    sur('#scdmMatieres', 'click', 'materiau', '[data-champ="matiere"]');
    sur('#scdmFinitions', 'click', 'finition', '[data-champ]');
    sur('#scdmQtes', 'click', 'quantite', '[data-champ],[data-val],button');
    sur('#scdmQteExacte', 'input', 'quantite');

    /* 6. Approbation - le design est au recapitulatif, puis la case est cochee. */
    var ajouter = document.getElementById('scdmAjouter');
    if (ajouter) {
      ajouter.addEventListener('click', function () {
        /* Ajouter un design ferme les cinq premieres etapes : le client vient
           de confirmer l ensemble de sa configuration. */
        ['fichier', 'dimensions', 'materiau', 'finition', 'quantite'].forEach(function (c) { faits[c] = true; });
        peindre();
      });
    }
    var ok = document.getElementById('scdmApproOk');
    if (ok) ok.addEventListener('change', function () { if (ok.checked) fait('approbation'); });

    peindre();
  });
})();
